import { beautifulPhoneFormat } from '@app/helpers/beautifulPhoneFormat';
import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { AuthSchema } from '../types/authSchema';
import { getAuthMe } from '../services/getAuthMe';

const initialState: AuthSchema = {
  userEmail: null,
  userPhone: null,
  userId: null,
  isLoggedin: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.auth,
      };
    });
    builder.addCase(getAuthMe.fulfilled, (state, action) => {
      if (action.payload) {
        const { email, phone, id } = action.payload;
        state.userEmail = email;
        state.userPhone = beautifulPhoneFormat(phone);
        state.userId = id;
        state.isLoggedin = true;
      } else {
        state.userEmail = null;
        state.userPhone = null;
        state.userId = null;
        state.isLoggedin = false;
      }
    });
    builder.addCase(getAuthMe.rejected, () => initialState);
  },
});

export const { actions: authActions } = authSlice;
